module.exports = __webpack_public_path__ + "static/img/toutu(1).e4779e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toutu(1).png
// module id = +3q9
// module chunks = 26